import { Tab } from '@mui/material';
import { makeStyles } from '@mui/styles';

import useParentSelection from './useParentSelection';

const useStyles = makeStyles(
  ({ spacing, palette, typography }) => ({
    root: {
      color: palette.text.onMain,
      ...typography.body1,
      opacity: 1,
      textTransform: 'none',
      textAlign: 'left',
      alignItems: 'start',
      paddingLeft: spacing(6),
      position: 'relative',
      '&:hover': {
        backgroundColor: palette.background.alternative,
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: spacing(4),
        height: '100%',
        width: 2,
        backgroundColor: palette.layout.line.divider,
      },
    },
    wrapper: {
      alignItems: 'flex-start',
    },
    selected: {
      fontWeight: typography.fontWeightMedium,
      color: [palette.primary.main, '!important'],
    },
  }),
  { classNamePrefix: 'DrawerMenuAnchorItem' }
);

function DrawerMenuAnchorItem({ label = '', onClick = null, selected = false, ...otherProps }) {
  useParentSelection(selected);

  const classes = useStyles();

  return (
    <Tab classes={classes} label={label} onClick={onClick} selected={selected} {...otherProps} />
  );
}

export default DrawerMenuAnchorItem;
